import { BoundaryRingSections } from "./EditBoundary";
import { Checkbox, FormControlLabel, FormGroup } from "@mui/material";
import { DeepPartial, mergeDeep } from "portal/utils/objects";
import { Section } from "portal/components/map/navigation/Section";
import { useCanEditFarmGeometry } from "portal/views/farms/permissions";
import { useTranslation } from "react-i18next";
import { Zone as ZoneType } from "protos/farm/farm";
import React, { FC } from "react";

interface ObstacleProps {
  zone: ZoneType;
  updateZone: (newZone: DeepPartial<ZoneType>) => void;
}

export const Obstacle: FC<ObstacleProps> = ({
  zone,
  updateZone,
}: ObstacleProps) => {
  const { t } = useTranslation();
  const canEditGeometry = useCanEditFarmGeometry();

  return (
    <div className="flex flex-col">
      {zone.contents?.obstacle && (
        <Section header={t("models.farms.obstacle_one")}>
          <FormGroup className="px-4">
            <FormControlLabel
              control={
                <Checkbox
                  checked={zone.contents.obstacle.passable}
                  disabled={!canEditGeometry}
                />
              }
              label={t("utils.descriptors.passable")}
              onChange={(_e, checked) => {
                const updatedZone = mergeDeep(zone, {
                  contents: {
                    obstacle: { passable: checked },
                  },
                  version: {
                    changed: true,
                  },
                });
                updateZone(updatedZone);
              }}
            />
          </FormGroup>
        </Section>
      )}
      <BoundaryRingSections zone={zone} />
    </div>
  );
};
